import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=2e50b741"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=2e50b741&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports